import Vue from 'vue'
import { getTenantId } from './auth'
// 初始化监控
const blmMonitor = window.__blmMonitor
blmMonitor && blmMonitor.monitor && blmMonitor.monitor.init({
  channel: 'web', // 渠道
  pid: 'vehicle_web', // p_业务线_业务
  uid: getTenantId(),
  Vue, // 如果是vue 项目则传入Vue构造函数对象
})

// 自定义监控上报方法
const customerror = function (msg = '', ext = {}, line = 0, col = 0) {
  const basic = {
    errorType: 'customerror', // 必传 错误类型、目前只支持customerror String
    msg, // 必传 错误信息 String
    line, // 非必传 错误行 Number
    col, // 非必传 错误列 Number
  }
  try {
    // ext 非必传 扩展信息 Object
    // eslint-disable-next-line no-undef
    __blmMonitor_report && __blmMonitor_report(basic, ext)
  } catch (e) {
    console.log(e)
  }
}

Vue.prototype.$blmMonitor = customerror

export { customerror }
